import { mdiCheck, mdiDiamondStone } from "@mdi/js";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../ui/components/button/Button";
import { Icon } from "../../../../ui/components/icon/Icon";
import { Modal } from "../../../../ui/components/modal/Modal";
import { Typography } from "../../../../ui/components/typography/Typography";
import { opn } from "../../../../util/api";
import { Campaign, Content, Section, nexusModsURL, } from "../../../../util/util";
import { PREMIUM_PATH } from "../../../nexus_integration/constants";
const ListItem = ({ children }) => (React.createElement("li", { className: "flex gap-x-1" },
    React.createElement(Icon, { className: "mt-0.5 shrink-0 text-premium-strong", path: mdiCheck, size: "xs" }),
    children));
export const PremiumModal = ({ isOpen, onClose, onDownload, }) => {
    const { t } = useTranslation(["health_check"]);
    const goPremium = React.useCallback(() => {
        opn(nexusModsURL(PREMIUM_PATH, {
            section: Section.Users,
            campaign: Campaign.BuyPremium,
            content: Content.HealthCheckAd,
        })).catch(() => undefined);
    }, []);
    return (React.createElement(Modal, { isOpen: isOpen, title: t("premium::modal::title"), onClose: onClose },
        React.createElement(Typography, { appearance: "subdued", as: "div", className: "space-y-2", typographyType: "body-sm" },
            React.createElement("p", null, t("premium::modal::description")),
            React.createElement("p", null, t("premium::modal::benefits_title")),
            React.createElement("ul", { className: "space-y-2" },
                React.createElement(ListItem, null, t("premium::modal::benefits::downloads")),
                React.createElement(ListItem, null, t("premium::modal::benefits::collections")),
                React.createElement(ListItem, null, t("premium::modal::benefits::speed")),
                React.createElement(ListItem, null, t("premium::modal::benefits::ad_free")))),
        React.createElement("div", { className: "mt-4 grid grid-cols-2 gap-x-2" },
            React.createElement(Button, { buttonType: "tertiary", className: "w-full", filled: "weak", size: "sm", onClick: onDownload }, t("premium::modal::buttons::download")),
            React.createElement(Button, { buttonType: "premium", className: "w-full", leftIconPath: mdiDiamondStone, size: "sm", onClick: goPremium }, t("premium::modal::buttons::premium")))));
};
